export default function Maps_Intro() {
  return (
    <div>
      <h1>Maps_Intro Component</h1>
    </div>
  );
}
